export const animals = [
  { name: "alligator" },
  { name: "alpaca" },
  { name: "ant" },
  { name: "anteater" },
  { name: "antelope" },
  { name: "ape" },
  { name: "armadillo" },
  { name: "baboon" },
  { name: "badger" },
  { name: "bat" },
  { name: "bear" },
  { name: "beaver" },
  { name: "bison" },
  { name: "boar" },
  { name: "buffalo" },
  { name: "camel" },
  { name: "capybara" },
  { name: "caribou" },
  { name: "cat" },
  { name: "cattle" },
  { name: "chamois" },
  { name: "cheetah" },
  { name: "chimpanzee" },
  { name: "chinchilla" },
  { name: "coyote" },
  { name: "crocodile" },
  { name: "deer" },
  { name: "dog" },
  { name: "donkey" },
  { name: "echidna" },
  { name: "eland" },
  { name: "elephant" },
  { name: "elk" },
  { name: "ferret" },
  { name: "fox" },
  { name: "frog" },
  { name: "gaur" },
  { name: "gazelle" },
  { name: "gerbil" },
  { name: "giant-panda" },
  { name: "giraffe" },
  { name: "gnu" },
  { name: "goat" },
  { name: "goose" },
  { name: "gorilla" },
  { name: "guanaco" },
  { name: "guinea-pig" },
  { name: "hamster" },
  { name: "hare" },
  { name: "hedgehog" },
  { name: "herring" },
  { name: "hippopotamus" },
  { name: "horse" },
  { name: "human" },
  { name: "hyena" },
  { name: "ibex" },
  { name: "jackal" },
  { name: "jaguar" },
  { name: "kangaroo" },
  { name: "koala" },
  { name: "komodo-dragon" },
  { name: "kouprey" },
  { name: "kudu" },
  { name: "lemur" },
  { name: "leopard" },
  { name: "lion" },
  { name: "llama" },
  { name: "loris" },
  { name: "lynx" },
  { name: "manatee" },
  { name: "mandrill" },
  { name: "marten" },
  { name: "meerkat" },
  { name: "mink" },
  { name: "mole" },
  { name: "mongoose" },
  { name: "monkey" },
  { name: "moose" },
  { name: "mouse" },
  { name: "mule" },
  { name: "okapi" },
  { name: "opossum" },
  { name: "oryx" },
  { name: "otter" },
  { name: "ox" },
  { name: "oyster" },
  { name: "panther" },
  { name: "pig" },
  { name: "polar-bear" },
  { name: "pony" },
  { name: "porcupine" },
  { name: "porpoise" },
  { name: "prairie-dog" },
  { name: "rabbit" },
  { name: "raccoon" },
  { name: "ram" },
  { name: "rat" },
  { name: "raven" },
  { name: "red-deer" },
  { name: "red-panda" },
  { name: "reindeer" },
  { name: "rhinoceros" },
  { name: "salamander" },
  { name: "sea-lion" },
  { name: "seal" },
  { name: "sheep" },
  { name: "skunk" },
  { name: "spider" },
  { name: "squirrel" },
  { name: "tapir" },
  { name: "tarsier" },
  { name: "tiger" },
  { name: "wallaby" },
  { name: "walrus" },
  { name: "water-buffalo" },
  { name: "weasel" },
  { name: "wolf" },
  { name: "wombat" },
  { name: "yak" },
  { name: "zebra" },
];
